module.exports = __webpack_public_path__ + "media/images/icon/check-507434dce4a8e4483b13ef139ad7831e.svg";